import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const AiAssistantFormWrapper = styled.div`
  min-width: min(100%, 480px);
  max-width: min(calc(100% - 110px), 600px);
  width: 100%;
  height: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 32px 24px;
  gap: 24px;

  .text-container-wrapper {
    position: relative;
    width: 100%;
    height: fit-content;
    border-radius: 12px;
    border: 1px solid ${colors.grey33};
    padding: 8px 12px;
    display: flex;
    width: 100%;
    flex-direction: column;
    &.row {
      flex-direction: row;
    }
    .next-button {
      width: 80px;
      align-self: flex-end;
    }
    &__side-next {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      gap: 4px;
      .next-icon-button {
        background: ${colors.primary};
        width: 30px;
        height: 30px;
        padding: 0px;
        :hover {
          background: ${colors.primaryDark};
        }
        .icon-right-arrow {
          height: 24px;
          width: 24px;
        }
        &.disabled {
          background: ${colors.grey2};
          cursor: default;
        }
      }
    }
  }
  .ai-assistant-form__section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    &.split {
      flex-direction: row;
    }
    &__lengths {
      display: grid;
      grid-template-columns: auto auto auto;
      column-gap: 8px;
    }
    .section-name {
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
    }
    &.disabled {
      cursor: default;
      opacity: 0.5;
      pointer-events: none;
    }
    .ai-assistant-step-title {
      &.disabled {
        cursor: pointer;
        opacity: 0.5;
      }
    }
    .ai-assistant-step-title-box {
      display: flex;
      align-items: center;
      gap: 8px;
      .icon-information-wrapper {
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        .icon-information {
          > path {
            stroke: ${colors.grey11};
          }
          cursor: pointer;
          :hover {
            > path {
              stroke: ${colors.primaryDark};
            }
          }
        }
      }
    }
    .ai-assistant-step-content-not-selected {
      border-radius: 8px;
      padding: 12px;
      background: ${colors.grey6};
      width: 100%;
      overflow: hidden;
      cursor: pointer;
      word-break: break-word;
      &.disabled {
        color: ${colors.grey11};
      }
      &.hoverable-for-edit {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .edit-icon {
          display: none;
          cursor: pointer;
          height: 20px;
          width: 20px;
          flex-shrink: 0;
        }
        :hover {
          background: ${colors.grey444};
          .edit-icon {
            display: block;
          }
        }
      }
    }
    .list-option {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 100%;
      .close-icon {
        cursor: pointer;
        height: 24px;
        width: 24px;
        flex-shrink: 0;
      }
    }
    .wrapper-suggestions-options {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;
      &.disabled {
        cursor: default;
        opacity: 0.5;
        pointer-events: none;
      }
    }
    &-half {
      display: flex;
      flex: 1;
      flex-direction: column;
      gap: 8px;
    }
  }
`;
